module.exports = __webpack_public_path__ + "img/MY.26570db2.png";